import { jsx as o } from "react/jsx-runtime";
const s = ({ className: r, width: t = "13", height: l = "18", onClick: e }) => /* @__PURE__ */ o(
  "svg",
  {
    className: r,
    width: t,
    height: l,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 18",
    fill: "none",
    onClick: e,
    children: /* @__PURE__ */ o("path", { d: "M0 0H12.5492V17.9275L6.27461 11.6529L0 17.9275V0Z", fill: "currentColor" })
  }
);
export {
  s as default
};
